import { App } from "vue";
import "@popperjs/core";
import "bootstrap/scss/bootstrap.scss";

export function bootstrap(_: App): void {}
